<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="Documentos">
        <Documents />
      </el-tab-pane>
      <el-tab-pane label="KPI">
        <kpi />
      </el-tab-pane>
      <el-tab-pane label="Tennos">
        <TennosD />
      </el-tab-pane>
      <el-tab-pane label="Magytrack ">
        <MTR />
      </el-tab-pane>
      <el-tab-pane label="Rabbey">
        <RabD />
      </el-tab-pane>
      <el-tab-pane label="Magycop Sa">
        <magycorpSa />
      </el-tab-pane>
      <el-tab-pane label="Magycorp SRL">
        <MagycorpSRLDlist />
      </el-tab-pane>
      <el-tab-pane label="Magycorp Technologies srl">
        <magycorpTechnologiesSDl />
      </el-tab-pane>
      <el-tab-pane label="Ventafiel Technologies SRL">
        <VentafielTecnology />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import kpi from "@/views/modules/legal/KPI.vue";
import Documents from "@/views/modules/legal/documents/DocumentList.vue";
import MTR from "@/views/modules/legal/documents/DocumentListMagyt.vue";
import RabD from "@/views/modules/legal/documents/DocumentListRb.vue";
import TennosD from "@/views/modules/legal/documents/DocumentListTenn.vue";
import magycorpSa from "./lagalOtherDocument/MagycorpSaDocumentL";
import MagycorpSRLDlist from "./lagalOtherDocument/MagycorpSRLDlist";
import magycorpTechnologiesSDl from "./lagalOtherDocument/magycorpTechnologiesSDl";
import VentafielTecnology from "./lagalOtherDocument/ventafielTecnology.vue";

export default {
  components: {
    kpi,
    Documents,
    MTR,
    RabD,
    TennosD,
    magycorpSa,
    MagycorpSRLDlist,
    magycorpTechnologiesSDl,
    VentafielTecnology
  }
};
</script>

<style></style>
